import {Box, Typography} from "@mui/material";
import ouro from "../../assets/gold.png";
import React from "react";

export default function InsuranceGold() {
    return (
        <Box
            sx={{
                background: 'linear-gradient(to right, #FFC56D, #644903)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 1,
            }}
        >
            <Box>
                <img
                    src={ouro}
                    alt="Plano ouro"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '50%',
                    }}
                />
            </Box>
            <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', color: 'white' }}>
                OURO
            </Typography>
            <Typography variant="body2" color="white">
                Plano de 36 meses
            </Typography>
        </Box>
    )
}